var render = function render(){
  var _vm$protocolName;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "popup_wrap protocol_detail"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    },
    domProps: {
      "innerHTML": _vm._s("\"" + ((_vm$protocolName = _vm.protocolName) === null || _vm$protocolName === void 0 ? void 0 : _vm$protocolName.replace(/<[^>]*>?/g, "")) + "\"&nbsp;프로토콜")
    }
  })]), _c('a', [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0)])])]), _c('div', {
    key: _vm.forceReRender,
    staticClass: "popup_content"
  }, [_c('div', {
    staticClass: "popup_content_fix_top"
  }, [_c('div', {
    staticClass: "protocol_detailtop"
  }, [_c('ul', {
    staticClass: "protocol_detailtop_tab"
  }, [_c('li', {
    class: _vm.pageType == _vm.tabTypeList[0] ? 'on' : null,
    on: {
      "click": function ($event) {
        return _vm.tabSelectFunc(0);
      }
    }
  }, [_c('a', {
    staticClass: "icon1",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("트리보기")])]), _c('li', {
    class: _vm.pageType == _vm.tabTypeList[1] ? 'on' : null,
    on: {
      "click": function ($event) {
        return _vm.tabSelectFunc(1);
      }
    }
  }, [_c('a', {
    staticClass: "icon2",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("위키보기")])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageType == _vm.tabTypeList[0],
      expression: "pageType == tabTypeList[0]"
    }],
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "tree",
    attrs: {
      "id": "tree-protocol"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageType == _vm.tabTypeList[1],
      expression: "pageType == tabTypeList[1]"
    }],
    staticClass: "popup_content2"
  }, [_c('div', {
    staticClass: "wiki_container"
  }, [_vm.showWikiIndex ? _c('div', {
    staticClass: "wiki_sidebar"
  }, [_vm.wikiIndex ? _c('WikiIndex', {
    attrs: {
      "indexList": _vm.titleIndex,
      "scrollMode": true
    },
    on: {
      "itemSelect": _vm.checkTitlePosition,
      "mounted": function (data) {
        return _vm.bookmarkInfo = data;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "wiki_content",
    class: {
      'full-width': !_vm.showWikiIndex
    }
  }, [_c('div', {
    ref: "wikiWrap",
    staticClass: "wiki_content_inner",
    on: {
      "scroll": _vm.moveScroll
    }
  }, [_vm.isProcess.isProcess ? _c('Process', {
    attrs: {
      "item": _vm.isProcess
    },
    on: {
      "load-content": function (status) {
        return _vm.awaitContent('process', status);
      }
    }
  }) : _vm._e(), _vm.isKeyword.isKeyword ? _c('Keyword', {
    attrs: {
      "item": _vm.isKeyword,
      "readonly": true
    },
    on: {
      "load-content": function (status) {
        return _vm.awaitContent('keyword', status);
      }
    }
  }) : _vm._e(), _vm._l(_vm.nodeData, function (data) {
    return _c('WikiContent', {
      key: data.id || data.key,
      attrs: {
        "editor": data
      }
    });
  })], 2)])])])]), _c('div', {
    staticClass: "popup_footer"
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1), _vm.visible ? _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

}]

export { render, staticRenderFns }